module.exports = __webpack_public_path__ + "static/media/dry.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dry.jpg
// module id = 882
// module chunks = 0